import React from "react";
import { withTranslation } from "react-i18next";
import { Dialog } from "hesus-ui-kit";
import PropTypes from "prop-types";

import {
  AllocationWarningTitle,
  AllocationWarningMessage,
  AllocationWarningContainer,
  SolutionButtonContainer,
  CancelButton,
  ConfirmButton,
} from "./AllocationWarning.styled";

const AllocationWarning = (props) => {
  const { t, onYes, onNo } = props;

  return (
    <Dialog>
      <AllocationWarningContainer>
        <AllocationWarningTitle>
          {t(
            "REQUEST_SOLUTIONS_VALIDATION_ALLOCATION_POP_UP_CANCEL_CONFIRMATION_TITLE"
          )}
        </AllocationWarningTitle>
        <AllocationWarningMessage>
          {t(
            "REQUEST_SOLUTIONS_VALIDATION_ALLOCATION_POP_UP_CANCEL_CONFIRMATION_CONTENT"
          )}
        </AllocationWarningMessage>
        <SolutionButtonContainer>
          <ConfirmButton onClick={onYes}>
            {t(
              "REQUEST_SOLUTIONS_VALIDATION_ALLOCATION_POP_UP_CANCEL_CONFIRMATION_YES"
            )}
          </ConfirmButton>
          <CancelButton onClick={onNo}>
            {t(
              "REQUEST_SOLUTIONS_VALIDATION_ALLOCATION_POP_UP_CANCEL_CONFIRMATION_NO"
            )}
          </CancelButton>
        </SolutionButtonContainer>
      </AllocationWarningContainer>
    </Dialog>
  );
};

AllocationWarning.propTypes = {
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AllocationWarning);
